import { createActions } from 'reduxsauce';

var _createActions = createActions({
  toggleWaitlist: ['waitlistActive'],
  changeInput: function changeInput(e) {
    var obj = {
      type: 'WAITLIST_CHANGE_INPUT'
    };
    obj[e.target.name] = e.target.value;
    return obj;
  },
  setLocation: ['location'],
  available: function available(json) {
    return {
      type: 'WAITLIST_AVAILABLE',
      results: json.data.results
    };
  },
  status: function status(json) {
    return {
      type: 'WAITLIST_STATUS',
      results: json.data.results
    };
  },
  request: function request() {
    return {
      type: 'WAITLIST_REQUEST'
    };
  },
  response: function response(json, location) {
    return {
      type: 'WAITLIST_RESPONSE',
      results: json.data.results,
      storeId: location,
      receivedAt: Date.now()
    };
  },
  toggleForm: function toggleForm() {
    return {
      type: 'WAITLIST_TOGGLE_FORM'
    };
  },
  update: function update(json, location) {
    return {
      type: 'WAITLIST_RESPONSE',
      results: json.data.results,
      storeId: location,
      receivedAt: Date.now()
    };
  },
  cancel: function cancel(json) {
    return {
      type: 'WAITLIST_CANCEL' // results: json.data.results,

    };
  },
  checkin: function checkin(json) {
    return {
      type: 'WAITLIST_CHECKIN',
      checkedIn: json.isUserCheckedIn,
      isUserAtRestaurant: json.checkedIn == true
    };
  },
  toggleWaitListCheckInModal: function toggleWaitListCheckInModal(show) {
    return {
      type: 'WAITLIST_TOGGLE_WAITLIST_CHECK_IN_MODAL',
      show: show
    };
  },
  reset: function reset(err) {
    return {
      type: 'WAITLIST_RESET',
      err: err
    };
  }
}, {
  prefix: 'WAITLIST_'
}),
    Creators = _createActions.Creators,
    Types = _createActions.Types;

export default {
  Creators: Creators,
  Types: Types
};